/** お知らせを出しておく時間 */
export const TOAST_DURATION_MS = 4000
